import React, { useCallback, useContext } from "react"
import { Button, CircularProgress, Grid } from "@mui/material"
import { PageHeading } from "../../../partials/layout/heading/page-heading"
import { useTranslation } from "react-i18next"
import { useLazyQuery } from "@apollo/client"
import {
  HOUSEHOLD_CONTAINERS_EXPORT_QUERY,
  HouseholdContainersExportResult,
  HouseholdContainersExportVariables,
} from "../../../../api/graphql/queries/household-containers-export"
import { HouseholdOverviewFilterContext } from "../context/household-overview-filter-context"
import { DownloadManagerContext } from "../../../partials/download-manager/download-manager-context"
import { toast } from "react-toastify"
import { useSelectedRegion } from "../../../../hooks/use-selected-region"

interface IHouseholdOverviewHeaderProps {}

export const HouseholdOverviewHeader: React.FC<IHouseholdOverviewHeaderProps> = (props) => {
  const { filter } = useContext(HouseholdOverviewFilterContext)
  const { t } = useTranslation()
  const { variables } = useSelectedRegion()
  const { setTriggerQuery } = useContext(DownloadManagerContext)

  const [fileExport, { loading }] = useLazyQuery<HouseholdContainersExportResult, HouseholdContainersExportVariables>(
    HOUSEHOLD_CONTAINERS_EXPORT_QUERY,
    {
      onCompleted: (data) => {
        if (!data.householdContainersExport) {
          toast.error(t("export.unknown_error"))
        }
        setTriggerQuery(true)
      },
    },
  )

  const onClick = useCallback(() => {
    fileExport({
      variables: {
        countyIds: filter.selectedCounties.map((option) => option.id),
        materialIds: filter.selectedMaterials.map((option) => option.id),
        regionType: variables.type,
        regionId: variables.id,
        townIds: filter.selectedTowns.map((option) => option.id),
        address: filter.address ? filter.address : null,
        showWarnings: filter.showWarnings,
      },
    })
  }, [filter, variables, fileExport])

  return (
    <Grid container justifyContent="space-between">
      <Grid item>
        <PageHeading>{t("collection_points.heading")}</PageHeading>
      </Grid>
      <Grid item>
        <Button onClick={onClick} variant="contained" disabled={loading} color="primary" sx={{ minWidth: 200 }}>
          {!loading && t("collection_points.export_containers")}
          {loading && <CircularProgress size={25} />}
        </Button>
      </Grid>
    </Grid>
  )
}
